module.exports = __webpack_public_path__ + "static/media/fit-cereja.1ecea9b9.webp";